<template>
  <transition name="el-fade-in-linear">
  <div v-show="transitionshow">     
      
      <el-form :inline="true" class="backborder1 demo-form-inline" size="small">
          <el-form-item style="width:18%">
          	  <el-date-picker v-model="query.date" type="daterange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" value-format="yyyy-MM-dd" :unlink-panels="false" style="width:100%" @change="ischange=true"></el-date-picker>
          </el-form-item>
          <el-form-item style="width:8%"  v-if="$cookies.get('agentid')==36">
		        <el-select v-model="query.datafrom" clearable remote  filterable placeholder="请选择订单来源" @change="ischange=true">
	          	  <el-option v-for="(item,index) in datafromlists" :label="item.name" :value="item.id" :key="index"></el-option>
	          </el-select>      
	        </el-form-item>
          <el-form-item style="width:8%" v-if="$cookies.get('agentid')==36">
		        <el-select v-model="query.type" clearable remote  filterable placeholder="商品类型" @change="ischange=true">
	          	  <el-option v-for="(item,index) in typelists" :label="item.name" :value="item.id" :key="index"></el-option>
	          </el-select>
          </el-form-item> 
          <el-form-item style="width:13%">
		          <el-select v-model="query.brandid" filterable clearable placeholder="按品牌"  @change="ischange=true">
		              <el-option v-for="(item,index) in brandlists" :label="item.showlable" :value="item.id" :key="index">
		              	  <span style="float: left">{{item.name}}</span>
      				        <span style="float: right; color: #C0C4CC; font-size: 13px">{{item.py}}</span>
		              </el-option>
		          </el-select>
	      </el-form-item>
          <el-form-item style="width:11%">
		        <el-select v-model="query.sorttype" clearable remote  filterable placeholder="排序方式" @change="ischange=true">
	          	    <el-option v-for="(item,index) in sortlists" :label="item.name" :value="item.id" :key="index"></el-option>
	            </el-select>
          </el-form-item> 
          <el-form-item style="width:19%">
	            <el-input placeholder="商品名称 / sku" clearable v-model="query.key" @keyup.enter.native="getlists" @change="ischange=true" style="width:100%"></el-input>
	      </el-form-item>
          <el-form-item>
              <el-button type="primary" icon="el-icon-search" @click="getlists">查询</el-button>
              <el-button type="success" icon="el-icon-download" @click="getexportdata" v-if="$cookies.get('agentid')==36">导出</el-button>
          </el-form-item>
      </el-form>

      <!-- 统计 -->
      <div class="alls">
          <div class="allssingle" style="background:#409EFF">
             <span style="float:left;padding:.3rem .7rem;background:#fff;color:#409EFF;border-radius:50%;font-size:.9rem;font-weight:bold">Al</span>
             <div style="float:left;width:62%;transition:all .5s">
                <span style="float:left;width:95%;font-size:.9rem;color:#fff;margin-left:5%;font-weight:bold;line-height:1.3rem">￥{{allsales.allsales}}</span>
                <span style="float:left;width:95%;font-size:.7rem;color:#fff;margin-left:5%;line-height:1.3rem">商品总销售额</span>
             </div>
          </div>
          <div class="allssingle" style="background:#F56C6C" v-if="$cookies.get('agentid')==36">
             <span style="float:left;padding:.3rem .7rem;background:#fff;color:#F56C6C;border-radius:50%;font-size:.9rem;font-weight:bold">JD</span>
             <div style="float:left;width:64%;transition:all .5s">
                <span style="float:left;width:95%;font-size:.9rem;color:#fff;margin-left:5%;font-weight:bold;line-height:1.3rem">￥{{allsales.jdsales}}</span>
                <span style="float:left;width:95%;font-size:.7rem;color:#fff;margin-left:5.5%;line-height:1.3rem">京东商品销售额</span>
             </div>
          </div>
          <div class="allssingle" style="background:#67C23A" v-if="$cookies.get('agentid')==36">
             <span style="float:left;padding:.3rem .7rem;background:#fff;color:#67C23A;border-radius:50%;font-size:.9rem;font-weight:bold">CZ</span>
             <div style="float:left;width:64%;transition:all .5s">
                <span style="float:left;width:95%;font-size:.9rem;color:#fff;margin-left:5%;font-weight:bold;line-height:1.3rem">￥{{allsales.czsales}}</span>
                <span style="float:left;width:95%;font-size:.7rem;color:#fff;margin-left:5.5%;line-height:1.3rem">宠赞商品销售额</span>
             </div>
          </div>
      </div>

      <div class="backborder2">
	      <el-table :data="lists" v-loading="listsloading">
              <el-table-column label="商品信息" align="left">
                  <template slot-scope="scope">
                      <div style="float:left;width:8%">
                        <i style="padding:.1rem .4rem;background:#f56c6c;border-color:#f56c6c;color:#fff;border-radius:50%;position:absolute;font-size:.1rem;font-style:normal;margin:-.6rem" v-if="scope.row.type=='京东' && $cookies.get('agentid')==36">JD</i>
                        <i style="padding:.1rem .4rem;background:#67C23A;border-color:#67C23A;color:#fff;border-radius:50%;position:absolute;font-size:.1rem;font-style:normal;margin:-.6rem" v-if="scope.row.type=='宠赞' && $cookies.get('agentid')==36">CZ</i>
                        <img :src="scope.row.thumb" style="float:left;width:100%;height:60px;border:1px solid rgb(221,221,221,.7);border-radius:5px"/>
                      </div>
                      <div style="float:left;width:86%;margin-left:2%">
                        <span style="float:left;width:100%;font-size:.8rem">{{scope.row.productname}}</span>
                        <span style="float:left;width:100%;color:#909399;font-size:.8rem" v-if="scope.row.spec!=''">规格：{{scope.row.propertyname}}</span>
                        <span style="float:left;width:100%;color:#909399;font-size:.8rem" v-if="scope.row.sku!='' && scope.row.sku!=null">sku：{{scope.row.sku}}</span>
                      </div>
                  </template>
              </el-table-column>
              <el-table-column prop="brandname" label="品牌" width="120" align="center"></el-table-column>
              <el-table-column prop="nums" label="销售数量" width="120" align="center"></el-table-column>
              <el-table-column prop="total" label="销售金额" width="120" align="center"></el-table-column>
              <el-table-column prop="cost" label="销售成本" width="120" align="center" v-if="$cookies.get('agentid')==36"></el-table-column>
              <el-table-column prop="profit" label="利润成本" width="120" align="center" v-if="$cookies.get('agentid')==36"></el-table-column>
              <el-table-column label="操作" align="center" width="100">
                  <template slot-scope="scope">
                      <el-button size="mini" type="primary" icon="el-icon-search" circle @click="getdetailorders(scope.row)"></el-button>
                  </template>
              </el-table-column>
          </el-table>
          <div class="block">
	          <!--分页begin-->
	          <el-pagination
	            @size-change="MallstatpageChange"
	            @current-change="MallstatpageCurrentChange"
	            :current-page="query.p"
	            :page-sizes="[10, 20, 50]"
	            :page-size="query.rollpage"
	            layout="total, sizes, prev, pager, next, jumper"
	            :total="rows">
	          </el-pagination>
	          <!--分页end-->
          </div>
      </div>

      <!-- 导出信息确认 -->
      <el-dialog title="导出商品销售统计信息确认" :visible.sync="exportDialog" width="90%" top="5vh">
	      	<el-button size="medium" type="danger" @click="customeroutput" style="float:right;margin-right:0;margin-bottom:15px">确认导出</el-button>
	      	<div id="outputorder">
		      	<el-table :data="exportdatalists" border v-loading="exportloading">
		      	  	<el-table-column prop="productname" label="商品名称" align="left"></el-table-column>
                    <el-table-column prop="propertyname" label="规格" width="120" align="left"></el-table-column>
                    <el-table-column prop="sku" label="商品sku" width="120" align="left"></el-table-column>
                    <el-table-column prop="brandname" label="品牌" width="120" align="left"></el-table-column>
                    <el-table-column prop="type" label="商品类型" width="120" align="center"></el-table-column>
                    <el-table-column prop="nums" label="销售数量" width="120" align="center"></el-table-column>
                    <el-table-column prop="total" label="销售金额" width="120" align="center"></el-table-column>
                    <el-table-column prop="cost" label="销售成本" width="120" align="center"></el-table-column>
                    <el-table-column prop="profit" label="利润成本" width="120" align="center"></el-table-column>
		      	</el-table>
	      	</div>
	      	<div slot="footer" class="dialog-footer">
		        <el-button size="medium" @click="exportDialog=false">取 消</el-button>
		        <el-button size="medium" type="danger" @click="customeroutput">确认导出</el-button>
		    </div>	                
	  </el-dialog>

      <!-- 商品销售详情 -->
      <el-dialog title="商品销售详情" :visible.sync="goodsaledtailDialog" width="95%" top="5vh">
          <el-table :data="goodsalesdetaillists" border v-loading="goodsalesLoading">
		      <el-table-column prop="ordernumbers" label="订单号" align="left" width="80"></el-table-column>
              <el-table-column prop="shopname" label="客户名称" width="90" align="left"></el-table-column>
              <el-table-column prop="productname" label="商品名称" align="left"></el-table-column>
              <el-table-column prop="propertyname" label="规格" width="100" align="left"></el-table-column>
              <el-table-column prop="datafrom" label="销售来源" width="100" align="center" v-if="$cookies.get('agentid')==36"></el-table-column>
              <el-table-column prop="numbers" label="销售数量" width="100" align="center"></el-table-column>
              <el-table-column prop="price" label="销售价格" width="100" align="center"></el-table-column>
              <el-table-column prop="total" label="销售小计" width="100" align="center"></el-table-column>
              <el-table-column prop="prices" label="所属订单实付金额" width="100" align="center"></el-table-column>
              <el-table-column prop="goodtotals" label="商品实付小计" width="100" align="center"></el-table-column>
              <el-table-column prop="cost" label="销售成本" width="100" align="center" v-if="$cookies.get('agentid')==36"></el-table-column>
              <el-table-column prop="profit" label="销售利润" width="100" align="center" v-if="$cookies.get('agentid')==36"></el-table-column>
              <el-table-column prop="inputtime" label="销售时间" width="110" align="center" v-if="$cookies.get('agentid')==36"></el-table-column>
		  </el-table>
          <div slot="footer" class="dialog-footer">
		      <el-button size="medium" @click="goodsaledtailDialog=false">取 消</el-button>
		  </div>	 
      </el-dialog>
          
  </div>
  </transition> 
</template>

<script>

export default {
  data () {
    return {
      url:this.GLOBAL.domain+"Mallstat/index",
      transitionshow:true,
      query: {
          act:'goodsaleslists',
          token:this.$cookies.get('token'),
          date:[new Date().getFullYear().toString() + '-' + (new Date().getMonth()+1) + '-' + new Date().getDate(),new Date().getFullYear().toString() + '-' + (new Date().getMonth()+1) + '-' + new Date().getDate()],
          datafrom:'',
          brandid:'',
          type:'',
          sorttype:'1',
          key:'',
          isexport:0,
          p:1,
          rollpage:10
      },
      datafromlists:[{id:1,name:'商城订单'},{id:2,name:'分销订单'}],
      typelists:[{id:1,name:'宠赞'},{id:2,name:'京东'}],
      sortlists:[{id:'1',name:'按销售额排序'},{id:'2',name:'按销售数量排序'}],
      brandlists:[],
      listsloading:false,
      rows:0,
      lists:[],
      allsales:[],
      exportloading:false,
      exportDialog:false,
      exportdatalists:[],
      goodsaledtailDialog:false,
      goodsalesLoading:false,
      goodsalesdetaillists:[],
    }  
  },
  mounted(){
     this.getBrand(); //获取品牌信息
  },
  methods:{

        /** 获取品牌 **/
	    getBrand(){
	        var resource = this.$resource(this.GLOBAL.domain+"Brand/index");
	        resource.save({act:'lists',token:this.$cookies.get('token'),rollpage:1000}).then((res) => {
		        if(res.data.Result>0){
		            if(res.data.Result=='70001') this.$router.push('/login')
		            this.$message.error(res.data.Message);
		        }else{
		        	var _this=this;
		            var result = JSON.parse(Base64.decode(res.data.Data));
		            this.brandlists=[];
		            result.forEach(function(e,i) {
		            	_this.brandlists.push({id:e.id,name:e.name,py:e.py,showlable:e.showlable});
		            });
		        }
	        }).catch((res) => {
	            //this.$message.error(this.GLOBAL.errortext);
	        });
	    },

      /** 查询商品信息 **/
      getlists() {
          if(this.ischange==true) {this.query.p=1;this.query.rollpage=10;}
          this.listsloading=true;
          var resource = this.$resource(this.url);
          this.query.isexport=0;
          resource.save(this.query).then((res) => {
              if(res.data.Result>0){
                  if(res.data.Result=='70001') this.$router.push('/login')
                  this.$message.error(res.data.Message);
                  this.listsloading=false;
              }else{
                  this.lists = JSON.parse(Base64.decode(res.data.Data));
	              this.rows=parseInt(res.data.count);
                  if(this.ischange==true) this.ischange=false;
                  this.listsloading=false;
                  this.getallsales(); //获取销售信息
              }
          }).catch((res) => {
              this.listsloading=false;
          });
      },

      MallstatpageChange(val) {
        this.query.rollpage = val;
        this.getlists();
      },
      MallstatpageCurrentChange(val) {
        this.query.p = val;
        this.getlists();
      },


      /** 获取统计信息 **/
      getallsales() {
          var resource = this.$resource(this.url);
          resource.save({act:'goodallsales',token:this.$cookies.get('token'),date:this.query.date,datafrom:this.query.datafrom,brandid:this.query.brandid,type:this.query.type,sorttype:this.query.sorttype,key:this.query.key}).then((res) => {
              if(res.data.Result>0){
                  if(res.data.Result=='70001') this.$router.push('/login')
                  this.$message.error(res.data.Message);
              }else{
                  this.allsales = JSON.parse(Base64.decode(res.data.Data));
              }
          }).catch((res) => {
              
          });
      },

      /** 导出商品销售信息 **/
      getexportdata() {
          this.exportloading=true;
          this.exportDialog=true;
          var resource = this.$resource(this.GLOBAL.exportUrl+"Mallstat/index");
          this.query.isexport=1;
          resource.save(this.query).then((res) => {
              if(res.data.Result>0){
                  if(res.data.Result=='70001') this.$router.push('/login')
                  this.$message.error(res.data.Message);
                  this.exportloading=false;
              }else{
                  this.exportdatalists = JSON.parse(Base64.decode(res.data.Data));
                  this.exportloading=false;
              }
          }).catch((res) => {
              this.exportloading=false;
          });
      },


      //按客户导出销售数据
      customeroutput() {
    	  this.exporthead=['商品名称','规格','sku','品牌','商品类型','销售数量','销售金额','销售成本','利润'];
	      this.exportfield=['productname','propertyname','sku','brandname','type','nums','total','cost','profit'];
	      this.exportname='线上商品销售统计报表';
	      this.exportput();
	      this.exportDialog=false;		
      },

      /** 确认导出信息 **/
      exportput() {
		  require.ensure([], () => {
			  var { export_json_to_excel } = require('../../vendor/Export2Excel');
			  var data = this.formatJson(this.exportfield, this.exportdatalists);
			  export_json_to_excel(this.exporthead, data, this.exportname);
		  })
      },
    
      //导出表格数据
	  formatJson(filterVal, jsonData) {
　　　　  return jsonData.map(v => filterVal.map(j => v[j]));
　　  },

     /** 获取商品销售信息详情 **/
     getdetailorders(item) {
          this.goodsaledtailDialog=true;
          this.goodsalesLoading=true;
          var resource = this.$resource(this.url);
          resource.save({act:'goodsalesdetail',token:this.$cookies.get('token'),date:this.query.date,datafrom:this.query.datafrom,propertyid:item.propertyid}).then((res) => {
              if(res.data.Result>0){
                  if(res.data.Result=='70001') this.$router.push('/login')
                  this.$message.error(res.data.Message);
                  this.goodsalesLoading=false;
              }else{
                  this.goodsalesdetaillists = JSON.parse(Base64.decode(res.data.Data));
                  this.goodsalesLoading=false;
              }
          }).catch((res) => {
              this.goodsalesLoading=false;
          });

     },

  }
}
</script>
<style>
.backborder1 {background:#fff;border-radius:15px;border:1px solid #ddd;padding:1% 1% 1% 1%}
.backborder2 {background:#fff;border-radius:15px;border:1px solid #ddd;padding:0 1% 3% 1%}
.datawarning {border-radius:5px;width:96%;padding:.3rem 2% .3rem 2%;margin-top:10px;background:rgb(221,221,221,.7);border:1px solid rgb(221,221,221,.9);min-height:1rem;overflow:hidden;transition: all .8s}
.dtitle {float:left;line-height:1.5rem;font-size:.7rem;color:red}
.dcontent {float:left;width:60%;margin-left:1%;}
.dcontent p {float:left;margin:0;width:100%;line-height:1.5rem;font-size:.7rem;color:red}
.datawarning a {cursor:pointer;float:left;margin-left:2%;width:1.5rem;height:1.5rem;background:#67C23A;border-radius:50%;transition: all .8s}
.datawarning a img{float:left;width:.6rem;margin-left:.45rem;margin-top:.45rem}
.alls {width:100%;padding:10px 0 10px 0;min-height:3.5rem;}
.allssingle {float:left;margin-right:1%;background:#fff;border-radius:5px;border:1px solid #ddd;padding:.5rem;}
</style>


// WEBPACK FOOTER //
// src/components/mall/Mallsalegoods.vue